"use strict";

var _regeneratorRuntime = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var queryString = require("query-string");

var jsontokens_1 = require("jsontokens");

var utils_1 = require("../utils");

var fetchUtil_1 = require("../fetchUtil");

var logger_1 = require("../logger");
/**
 * Retrieves the authentication request from the query string
 * @return {String|null} the authentication request or `null` if
 * the query string parameter `authRequest` is not found
 * @private
 * @ignore
 */


function getAuthRequestFromURL() {
  var location = utils_1.getGlobalObject('location', {
    throwIfUnavailable: true,
    usageDesc: 'getAuthRequestFromURL'
  });
  var queryDict = queryString.parse(location.search);

  if (queryDict.authRequest) {
    return queryDict.authRequest.split("".concat(utils_1.BLOCKSTACK_HANDLER, ":")).join('');
  } else {
    return null;
  }
}

exports.getAuthRequestFromURL = getAuthRequestFromURL;
/**
 * Fetches the contents of the manifest file specified in the authentication request
 *
 * @param  {String} authRequest encoded and signed authentication request
 * @return {Promise<Object|String>} Returns a `Promise` that resolves to the JSON
 * object manifest file unless there's an error in which case rejects with an error
 * message.
 * @private
 * @ignore
 */

function fetchAppManifest(authRequest) {
  return tslib_1.__awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var payload, manifestURI, response, responseText, responseJSON;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (authRequest) {
              _context.next = 2;
              break;
            }

            throw new Error('Invalid auth request');

          case 2:
            payload = jsontokens_1.decodeToken(authRequest).payload;

            if (!(typeof payload === 'string')) {
              _context.next = 5;
              break;
            }

            throw new Error('Unexpected token payload type of string');

          case 5:
            manifestURI = payload.manifest_uri;
            _context.prev = 6;
            logger_1.Logger.debug("Fetching manifest from ".concat(manifestURI));
            _context.next = 10;
            return fetchUtil_1.fetchPrivate(manifestURI);

          case 10:
            response = _context.sent;
            _context.next = 13;
            return response.text();

          case 13:
            responseText = _context.sent;
            responseJSON = JSON.parse(responseText);
            return _context.abrupt("return", Object.assign(Object.assign({}, responseJSON), {
              manifestURI: manifestURI
            }));

          case 18:
            _context.prev = 18;
            _context.t0 = _context["catch"](6);
            console.log(_context.t0);
            throw new Error('Could not fetch manifest.json');

          case 22:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[6, 18]]);
  }));
}

exports.fetchAppManifest = fetchAppManifest;
/**
 * Redirect the user's browser to the app using the `redirect_uri`
 * specified in the authentication request, passing the authentication
 * response token as a query parameter.
 *
 * @param {String} authRequest  encoded and signed authentication request token
 * @param {String} authResponse encoded and signed authentication response token
 * @return {void}
 * @throws {Error} if there is no redirect uri
 * @private
 * @ignore
 */

function redirectUserToApp(authRequest, authResponse) {
  var payload = jsontokens_1.decodeToken(authRequest).payload;

  if (typeof payload === 'string') {
    throw new Error('Unexpected token payload type of string');
  }

  var redirectURI = payload.redirect_uri;
  logger_1.Logger.debug(redirectURI);

  if (redirectURI) {
    redirectURI = utils_1.updateQueryStringParameter(redirectURI, 'authResponse', authResponse);
  } else {
    throw new Error('Invalid redirect URI');
  }

  var location = utils_1.getGlobalObject('location', {
    throwIfUnavailable: true,
    usageDesc: 'redirectUserToApp'
  });
  location.href = redirectURI;
}

exports.redirectUserToApp = redirectUserToApp;